import { render, staticRenderFns } from "./ContractTemplateForm.vue?vue&type=template&id=ba2e85c4&scoped=true"
import script from "./ContractTemplateForm.vue?vue&type=script&lang=js"
export * from "./ContractTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./ContractTemplateForm.vue?vue&type=style&index=0&id=ba2e85c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2e85c4",
  null
  
)

export default component.exports